import { tv } from 'tailwind-variants';

import { Flag, Icon } from '@frontendmentorio/design-system-v2';

export const TYPES = {
  free: { label: 'Free' },
  'free-plus': { label: 'Free+' },
  new: {
    icon: <Icon name="star-of-life" style="solid" />,
    label: 'New',
  },
  premium: { label: 'Premium' },
  private: {
    icon: <Icon name="lock-keyhole" style="solid" />,
    label: 'Private',
  },
};

const styles = tv({
  base: ['flex', 'gap-1', 'items-center'],
  variants: {
    type: {
      free: ['bg-blue-100', 'text-blue-500'],
      'free-plus': ['bg-orange-500'],
      new: ['bg-rose-600'],
      premium: ['bg-blue-500'],
      private: ['bg-cyan-500'],
    },
  },
});

export default function SharedFlag({ className, type }) {
  return (
    <Flag className={styles({ class: className, type })}>
      {TYPES[type].icon} {TYPES[type].label}
    </Flag>
  );
}
